var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "createManagedUserModal",
        size: "lg",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("admin.create_managed_user"),
      },
      on: {
        hide: function ($event) {
          return _vm.resetValues()
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.createUser()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.create")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("b-input-group-form-input", {
                attrs: {
                  id: "username-input",
                  "input-group-size": "mb-3",
                  type: "text",
                  lazy: "true",
                  required: "true",
                  feedback: "true",
                  autofocus: "false",
                  label: _vm.$t("message.username"),
                  "feedback-text": _vm.$t("admin.required_username"),
                },
                model: {
                  value: _vm.username,
                  callback: function ($$v) {
                    _vm.username = $$v
                  },
                  expression: "username",
                },
              }),
              _c("b-input-group-form-input", {
                attrs: {
                  id: "fullname-input",
                  "input-group-size": "mb-3",
                  type: "text",
                  lazy: "true",
                  required: "true",
                  feedback: "true",
                  autofocus: "false",
                  label: _vm.$t("message.fullname"),
                  "feedback-text": _vm.$t("admin.required_fullname"),
                },
                model: {
                  value: _vm.fullname,
                  callback: function ($$v) {
                    _vm.fullname = $$v
                  },
                  expression: "fullname",
                },
              }),
              _c("b-input-group-form-input", {
                attrs: {
                  id: "email-input",
                  "input-group-size": "mb-3",
                  type: "text",
                  lazy: "true",
                  required: "true",
                  feedback: "true",
                  autofocus: "false",
                  label: _vm.$t("message.email"),
                  "feedback-text": _vm.$t("admin.required_email"),
                },
                model: {
                  value: _vm.email,
                  callback: function ($$v) {
                    _vm.email = $$v
                  },
                  expression: "email",
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            [
              _c("b-input-group-form-input", {
                attrs: {
                  id: "password-input",
                  "input-group-size": "mb-3",
                  type: "password",
                  lazy: "true",
                  required: "true",
                  feedback: "true",
                  autofocus: "false",
                  label: _vm.$t("message.password"),
                  "feedback-text": _vm.$t("admin.required_password"),
                },
                model: {
                  value: _vm.password,
                  callback: function ($$v) {
                    _vm.password = $$v
                  },
                  expression: "password",
                },
              }),
              _c("b-input-group-form-input", {
                attrs: {
                  id: "confirmPassword-input",
                  "input-group-size": "mb-3",
                  type: "password",
                  lazy: "true",
                  required: "true",
                  feedback: "true",
                  autofocus: "false",
                  state: _vm.verifyPasswordState(),
                  label: _vm.$t("admin.password_confirm"),
                  "feedback-text": _vm.$t("admin.required_confirmPassword"),
                },
                model: {
                  value: _vm.confirmPassword,
                  callback: function ($$v) {
                    _vm.confirmPassword = $$v
                  },
                  expression: "confirmPassword",
                },
              }),
              _c(
                "c-switch",
                _vm._b(
                  {
                    attrs: {
                      id: "forcePasswordChange",
                      color: "primary",
                      label: "",
                    },
                    model: {
                      value: _vm.forcePasswordChange,
                      callback: function ($$v) {
                        _vm.forcePasswordChange = $$v
                      },
                      expression: "forcePasswordChange",
                    },
                  },
                  "c-switch",
                  _vm.labelIcon,
                  false
                )
              ),
              _vm._v(
                _vm._s(_vm.$t("admin.change_password_next_login")) + "\n      "
              ),
              _c("br"),
              _c(
                "c-switch",
                _vm._b(
                  {
                    attrs: {
                      id: "nonExpiryPassword",
                      color: "primary",
                      label: "",
                    },
                    model: {
                      value: _vm.nonExpiryPassword,
                      callback: function ($$v) {
                        _vm.nonExpiryPassword = $$v
                      },
                      expression: "nonExpiryPassword",
                    },
                  },
                  "c-switch",
                  _vm.labelIcon,
                  false
                )
              ),
              _vm._v(_vm._s(_vm.$t("admin.password_never_expires")) + "\n    "),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }